import React from 'react';
import { 
  EnvelopeIcon,   
  GlobeAltIcon, 
  CodeBracketIcon,
  LinkIcon,
  ShareIcon
} from '@heroicons/react/24/outline';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Projects', href: '#projects' },
  ];

  const technologies = [
    'Laravel', 'React', 'Vue.js', 'AWS', 'Docker', 'TypeScript'
  ];

  return (
    <footer id="contact" className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center mb-6">
                <CodeBracketIcon className="w-8 h-8 text-primary-400 mr-3" />
                <h3 className="text-2xl font-bold">Luis Panta</h3>
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
                Full-Stack Developer passionate about building scalable, high-performance web applications 
                and innovative digital solutions. Let's create something amazing together.
              </p>
              
              <div className="space-y-3">
                <div className="flex items-center text-gray-300">
                  <EnvelopeIcon className="w-5 h-5 mr-3 text-primary-400" />
                  <span>lupanvi@hotmail.com</span>
                </div>               
                <div className="flex items-center text-gray-300">
                  <GlobeAltIcon className="w-5 h-5 mr-3 text-primary-400" />
                  <span>Available for remote work worldwide</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6 text-primary-400">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href}
                      className="text-gray-300 hover:text-primary-400 transition-colors duration-300"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6 text-primary-400">Technologies</h4>
              <div className="flex flex-wrap gap-2">
                {technologies.map((tech) => (
                  <span 
                    key={tech}
                    className="px-3 py-1 bg-gray-800 text-gray-300 rounded-md text-sm font-medium border border-gray-700"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="text-gray-400 mb-4 md:mb-0">
                © {currentYear} Luis Panta. All rights reserved.
              </div>
              
              <div className="flex space-x-6">
                <a 
                  href="https://www.linkedin.com/in/luis-p-5b534946/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
                >
                  <LinkIcon className="w-6 h-6" />
                </a>
                <a 
                  href="https://github.com/lupanvi"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
                >
                  <ShareIcon className="w-6 h-6" />
                </a>
                <a 
                  href="mailto:lupanvi@hotmail.com"
                  className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
                >
                  <EnvelopeIcon className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-primary-600 to-blue-600 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-white font-medium">
            🚀 Let's build something amazing together - 
            <a 
              href="mailto:lupanvi@hotmail.com" 
              className="underline hover:no-underline ml-2"
            >
              Get in touch
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;